import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AztecScannerService} from '../../../../services/aztec-scanner.service';
import {DeviceService} from '../../../../services/device.service';
import {ApplicationStateService} from '../../../../services/application-state.service';
import {ApplicationContextService} from '../../../../../core/services/impl/configuration/application-context.service';

@Component({
  selector: 'app-aztec-scanner-info',
  templateUrl: './aztec-scanner-info.component.html',
  styleUrls: []
})
export class AztecScannerInfoComponent implements OnInit {

    @Input() sectionsBellow: boolean;
    @Output() openAztecScanner: EventEmitter<void> = new EventEmitter<void>();

    get aztecScannedFromQrCode(): boolean {
        return this.stateService.state.aztecScannedFromQrCode;
    }

    get dataEnteredManually(): boolean {
        return this.sectionsBellow && !this.aztecScannedFromQrCode;
    }

    get subtitle(): string {
        if (this.aztecScannedFromQrCode) {
            return 'AZTEC_SCANNER_INFO.subtitleScanned';
        } else {
            return this.dataEnteredManually ? 'AZTEC_SCANNER_INFO.footer' : 'INITIAL_DATA_SECTION.skipEnteringData';
        }
    }

    get dataClear(): boolean {
        return !this.aztecScannedFromQrCode && !this.dataEnteredManually;
    }

    get imageSrc(): string {
        return this.aztecScannedFromQrCode ? './assets/images/aztec-scanner-info-success.webp' : './assets/images/aztec-scanner-info.webp';
    }

    get diagnosticStationScanView(): boolean {
        return !this.aztecScannedFromQrCode && this.contextService.isDiagnosticStationContext;
    }

    get footerVisible(): boolean {
        return this.dataClear && !this.diagnosticStationScanView;
    }

  constructor(private deviceService: DeviceService,
              private aztecScannerService: AztecScannerService,
              private stateService: ApplicationStateService,
              private contextService: ApplicationContextService) { }

  ngOnInit() {
  }

  scanCode() {
      if (this.deviceService.isMobileDevice) {
        this.openAztecScanner.emit();
      } else {
          this.aztecScannerService.openAztecScannerQRDialog();
      }
  }

}
